<template>
  <div>
    <Form
      page-title="Edit Floor"
      buttonName="Update"
      :branchId="branchId"
      :businessId="businessId"
      :isInList="isInList"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { updateFloor } from "@/API/FloorsAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "businessId", "showAdd", "branchId"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateFloor(formData), callback);
    }
  }
};
</script>
<style></style>
